import React, { useEffect } from 'react';
import { injectScript } from "../../utilities/injectScript.js";

export default function GoogleSignInButton({onSignIn, onFailure}) {

	useEffect(() => {
		const script = injectScript.js({
			src: 'https://apis.google.com/js/platform.js'
		});
		script.onload = () => {
			gapi.signin2.render('google-signin', {
				'scope': 'https://www.googleapis.com/auth/plus.login',
				'longtitle': false,
				'theme': 'light',
				'onsuccess': onSignIn,
				'onfailure': onFailure,
			});
		};
	}, []);

	return (
		<div id='google-signin' />
	);
}